export default __webpack_public_path__ + "static/media/banner6 1.777085cc.svg";